module.exports = __webpack_public_path__ + "static/img/logo_footer.af07ccd3.svg";